import { render, staticRenderFns } from "./OnboardingWebhooksSettingsContent.vue?vue&type=template&id=21d818ed&scoped=true&lang=pug"
import script from "./OnboardingWebhooksSettingsContent.vue?vue&type=script&lang=ts"
export * from "./OnboardingWebhooksSettingsContent.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingWebhooksSettingsContent.vue?vue&type=style&index=0&id=21d818ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d818ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VIcon,VSwitch,VTextField,VTooltip})
